/**
 * Useful utilities
 */
import { useRef, useState } from 'react';
import { Subject } from 'rxjs';
import { pluck } from 'rxjs/operators';
/**
 * Returns the first argument it receives.
 */
export function identity(value) {
    return value;
}
/**
 * Maps an Observable of Arraylike to an Observable
 * of the first item.
 *
 * Example:
 *
 * ```typescript
 * const text$ = useObservable(pluckFirst, [props.text])
 * ```
 *
 * @param inputs$ An Observable of arraylike.
 *
 */
export function pluckFirst(inputs$) {
    return pluck(0)(inputs$);
}
/**
 * Maps an Observable of DOM events to an Observable
 * of the currentTarget value.
 *
 * Example:
 *
 * ```typescript
 * const [onChange, textChange$] = useObservableCallback<
 *  string,
 *  React.FormEvent<HTMLInputElement>
 * >(pluckCurrentTargetValue)
 * ```
 *
 */
export function pluckCurrentTargetValue(event$) {
    return pluck('currentTarget', 'value')(event$);
}
/**
 * Maps an Observable of DOM events to an Observable
 * of the currentTarget checked.
 *
 * Example:
 *
 * ```typescript
 * const [onChange, checked$] = useObservableCallback<
 *  boolean,
 *  React.FormEvent<HTMLInputElement>
 * >(pluckCurrentTargetChecked)
 * ```
 *
 */
export function pluckCurrentTargetChecked(event$) {
    return pluck('currentTarget', 'checked')(event$);
}
/**
 * Return an empty Subject
 * @ignore
 */
export function getEmptySubject() {
    return new Subject();
}
/**
 * Return an empty object
 * @ignore
 */
export function getEmptyObject() {
    return {};
}
/**
 * An empty tuple
 * @ignore
 */
export const EMPTY_TUPLE = [];
/**
 * One-time ref init.
 * @param init A function that returns a non-nullable value. Will be called only once.
 * @returns A ref object with the returned value.
 */
export function useRefFn(init) {
    const ref = useRef(null);
    if (ref.current === null) {
        ref.current = init();
    }
    return ref;
}
/**
 * Force re-render Component.
 */
export function useForceUpdate() {
    const updateState = useState(0)[1];
    return () => updateState(n => (n + 1) % 1000000);
}
//# sourceMappingURL=helpers.js.map